module.exports = __webpack_public_path__ + "static/media/Wave.952b70b8.png";